import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import OverviewContainer from "./OverviewContainer";

/*

This component and its container: OvUrlResolverContainer are responsible 
for parsing the url when the route starts with overview. It then sets 
some state based on the rest of the url and the query string.

"time" and "account" are the section names currently - more will be added.
If url is /overview/time or /overview/account resolveSectionRoute() will
set tabIndex to 0 or 1 respectively.

If it's just /overview, then rewrite it, based on whatever is in the redux store.

In this way, if you navigate to account for example, then navigate away completely, 
then click overview in the drawer again, it will go to the last selected tab.

This comp also resolves the query string which contains the state of all filters 
and some other chart settings (granularity for example). It does this with 
persistFilters() - see the container component.
*/

class OvUrlResolver extends Component {
  constructor(props) {
    super(props);
    this.clearIntervalIdForMonitoringMode = null;
    this.resolveSectionRoute = this.resolveSectionRoute.bind(this);
  }

  unSubscribeAutoupdate() {
    if (typeof this.clearIntervalIdForMonitoringMode === "number") {
      window.clearInterval(this.clearIntervalIdForMonitoringMode);
    }
  }

  resolveSectionRoute(props) {
    const {
      location,
      labels,
      persistTab,
      persistFilters,
      monitoringMode
    } = props;

    const section = location.pathname
      .split("/")
      .slice(-1)
      .pop();
    let tabIndex = labels.indexOf(section);

    if (tabIndex < 0) {
      tabIndex = props.tabIndex;
      props.history.push(`/overview/${labels[tabIndex]}`);
    } else {
      persistTab(tabIndex);
      persistFilters(labels[tabIndex]);
      this.unSubscribeAutoupdate();
      if (monitoringMode === true) {
        this.clearIntervalIdForMonitoringMode = window.setInterval(() => {
          persistTab(tabIndex);
          persistFilters(labels[tabIndex]);
        }, 60000);
      }
    }
  }

  componentDidMount() {
    this.resolveSectionRoute(this.props);
  }

  componentWillUnmount() {
    this.unSubscribeAutoupdate();
  }

  componentWillReceiveProps(nextProps) {
    this.resolveSectionRoute(nextProps);
  }

  render() {
    return <OverviewContainer {...this.props} />;
  }
}

OvUrlResolver.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  labels: PropTypes.array.isRequired,
  persistTab: PropTypes.func.isRequired,
  persistFilters: PropTypes.func.isRequired
};

export { OvUrlResolver };

export default withRouter(OvUrlResolver);



// WEBPACK FOOTER //
// ./src/OvUrlResolver.js